module.exports = __webpack_public_path__ + "static/logo-d9fdbf51ae9127e49be0b7287e566935.png";